import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/work/works')({
    beforeLoad: ({ search }) => {
        throw redirect({ to: '/works', search, replace: true })
    },
})
